<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="160px"
    >
      <el-form-item
        label="公司名称"
        prop="groupName"
      >
        <el-input
          v-model.trim="form.groupName"
          placeholder="请输入公司名称"
          clearable
          maxlength="256"
          @change="(value)=>{form.groupName = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="公司简称"
        prop="groupNameLocal"
      >
        <el-input
          v-model.trim="form.groupNameLocal"
          placeholder="请输入公司简称【发短信使用】"
          clearable
          @change="(value)=>{form.groupNameLocal = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="公司简称码"
        prop="organizationCode"
      >
        <el-input
          v-model="form.organizationCode"
          placeholder="请输入2-6位字母"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="统一社会信用代码"
        prop="uniformSocialCreditCode"
      >
        <el-input
          v-model="form.uniformSocialCreditCode"
          placeholder="请输入统一社会信用代码"
          clearable 
          @change="value=>{form.uniformSocialCreditCode = value.replace(/\W/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="道路运输证编号"
        prop="permitNumber"
      >
        <el-input
          v-model="form.permitNumber"
          placeholder="请输入道路运输经营许可证编号"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="公司地址"
        prop="address"
      >
        <el-input
          v-model="form.address"
          placeholder="请输入公司地址"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="公司网址"
        prop="wwwUrl"
      >
        <el-input
          v-model="form.wwwUrl"
          placeholder="请输入公司网址"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="400客服"
        prop="telephone"
      >
        <el-input
          v-model="form.telephone"
          placeholder="请输入400客服电话"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="上传证件"
        required
      >
        <ImgUpload :upload-config="{ lebal: '公司logo', prefix: 'logo', form: form, suffix: 'Url' }" />
        <ImgUpload
          :upload-config="{ lebal: '登录logo', prefix: 'loginLogo', form: form, suffix: 'Url' }"
        />
        <ImgUpload
          :upload-config="{ lebal: '统一社会信用代码', prefix: 'uniformSocialCreditCode', form: form, suffix: 'Url' }"
        />
        <ImgUpload :upload-config="{ lebal: '电信增值业务许可证ICP', prefix: 'icpImg', form: form, suffix: '' }" />
        <ImgUpload :upload-config="{ lebal: '软件著作权', prefix: 'softwareCopyrightImg', form: form, suffix: '' }" />
        <ImgUpload :upload-config="{ lebal: '服务器租赁协议', prefix: 'serverLeasingAgreement', form: form, suffix: '' }" />
        <ImgUpload
          :upload-config="{ lebal: '合同章', prefix: 'mis', form: form, suffix: 'Url' }"
          disabled
        />
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="getLimit('sysSetting_creditMis_button')"
          type="primary"
          @click="creditMis"
        >
          生成合同章
        </el-button>
        <el-button
          v-if="getLimit('sysSetting_submit_button')"
          type="primary"
          @click="funcSubmit"
        >
          确 定
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
import ImgUpload from "@/components/ImgUpload";
import {
  isURL,
  isPartyGroupPrefix,
  isBusinessLicenseImgNum
} from "@/utils/validate4Form";
export default {
  name: "SysSetting",
  components: {
    ImgUpload
  },
  data() {
    return {
      form: {},
      rules: {
        groupName: [
          {
            required: true,
            message: "请输入公司名称：机构/网点/入住企业",
            trigger: "blur"
          },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256 个字符",
            trigger: "blur"
          }
        ],
        groupNameLocal: [
          {
            required: true,
            message: "请输入公司简称3-7字符",
            trigger: "blur"
          },
          {
            min: 3,
            max: 7,
            message: "长度在 3 到 7 个字符",
            trigger: "blur"
          }
        ],
        organizationCode: [
          { required: true, message: "请输入公司简称码", trigger: "blur" },
          { validator: isPartyGroupPrefix, trigger: "blur" },
          { min: 2, max: 6, message: "长度在 2 到 6 个字符", trigger: "blur" }
        ],
        wwwUrl: [
          { required: true, message: "请输入公司网址", trigger: "blur" },
          { validator: isURL, trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        telephone: [
          { required: true, message: "请输入400客服电话", trigger: "blur" },
          { min: 1, max: 16, message: "长度在 1 到 16 个字符", trigger: "blur" }
        ],
        //  telephone: [
        //   { required: true, message: '请输入400客服电话', trigger: 'blur' },
        //   {
        //     validator(rule, value, callback) {
        //         validatePhone(value)?callback():validateTelephone(value)?callback():callback(new Error('电话格式有误'))
        //     },
        //     trigger: 'blur',
        //   },
        //   { min: 1, max: 16, message: "长度在 1 到 16 个字符", trigger: "blur" }
        // ],
        uniformSocialCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          { validator: isBusinessLicenseImgNum, trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        permitNumber: [
          {
            required: true,
            message: "请输入道路运输经营许可证编号",
            trigger: "blur"
          },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      return request({
        url: `/ntocc-basic-api/partyGroup/one`,
        method: "get"
      }).then(response => {
        if (response.data) {
          this.form = response.data;
        }
      });
    },
      creditMis(){
          return request({
              url: `/ntocc-basic-api/partyGroup/caculateCompanySeal`,
              method: "post",
              params: {uniformSocialCreditCode:this.form.uniformSocialCreditCode}
          }).then(response => {
             this.form.misUrl=response.data;
          });
      },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          if (data.code) {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "put",
              params: data
            }).then(response => {
              this.getInfo();
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            });
          } else {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "post",
              params: data
            }).then(response => {
              this.getInfo();
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>
